
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_stores",
      function () {
        return require("private-next-pages/_stores/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_stores"])
      });
    }
  